export default {
  Acordos: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "acordo"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Acordos.js
// module id = vFOT
// module chunks = 18